import auth from '@/router/auth'
import Login from '@/components/account/Login'
import Register from '@/components/account/Register'

export default [
  {
    path: '/login',
    name: 'account-login',
    component: Login
  },
  {
    path: '/register',
    name: 'account-register',
    component: Register
  },
  {
    path: '/account/show/:tab',
    name: 'account-show',
    component: () => import('@/components/account/Show'),
    beforeEnter: auth.requireAuth
  },
  {
    path: '/account/reset-pass',
    name: 'account-reset-pass',
    component: () => import('@/components/account/ResetPass'),
    beforeEnter: auth.requireAuth
  },
  {
    path: '/account/upgrade',
    name: 'account-upgrade',
    component: () => import('@/components/account/Upgrade'),
    beforeEnter: auth.requireAuth
  },
  {
    path: '/account/username',
    name: 'account-username',
    component: () => import('@/components/account/Username'),
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/account/router.js